const STATUS_TYPES = ['WATER', 'ROAD']

export { STATUS_TYPES }
